import * as EveryPortCard from './EveryPortCard/EveryPortCard.css';
export default {
    EveryPortCard
};
